<template>
    <div >
      <v-container fill-height fluid>
        <v-row align="center"
            justify="center"
            class="text-center">
            <v-col
                cols="6"
                md="6"
              >
            </v-col>
            <v-col
              cols="1"
              md="1"
              >
              <v-progress-circular
                indeterminate
                color="#8A2BE2"
              ></v-progress-circular>
            </v-col>
            <v-col
                cols="5"
                md="5"
              >
            </v-col>
        </v-row>
      </v-container>
    </div>
</template>


<script>
export default {
  name: 'Loading',
}
</script>
